import { jsx as _jsx } from "react/jsx-runtime";
import { Box } from "@mui/material";
const resultConfig = {
    W: { color: "#fff", bgColor: "#538D4E" },
    D: { color: "#fff", bgColor: "#86868F" },
    L: { color: "#fff", bgColor: "#D32F2F" },
};
export const FormIndicator = ({ results }) => {
    return (_jsx(Box, { sx: { display: "flex", gap: 0.5, justifyContent: "flex-start" }, children: results.map((result, index) => {
            const config = resultConfig[result];
            return (_jsx(Box, { sx: {
                    width: 20,
                    height: 20,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    borderRadius: "3px",
                    fontSize: "0.7rem",
                    fontWeight: 700,
                    color: config.color,
                    bgcolor: config.bgColor,
                    lineHeight: 1,
                }, children: result }, index));
        }) }));
};
